<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="responsive-card-title" i18n>Deposits</div>

    <ng-container *ngIf="!hasChanges">
      <app-review-deposit-details-deposit-card
        [bankAccount]="currentBankAccount"
        [isWrittenCheque]="!currentBankAccount" />
    </ng-container>

    <ng-container *ngIf="hasChanges">
      <div class="d-flex flex-column gap-3">
        <div class="d-flex flex-column gap-2">
          <span class="change-label" i18n>Current</span>
          <app-vb-payment-change-deposit-detail-change-accordion
            class="current-highlight"
            [bankAccount]="currentBankAccount"
            [isWrittenCheque]="!currentBankAccount" />
        </div>

        <div class="d-flex flex-column gap-2">
          <span class="change-label" i18n>New</span>
          <app-vb-payment-change-deposit-detail-change-accordion
            class="new-highlight"
            [bankAccount]="newBankAccount"
            [isWrittenCheque]="!newBankAccount" />
        </div>
      </div>
    </ng-container>
  </div>
</div>
